import React from 'react'

import { getSelectedPromocode } from '../../../utils/SettingsRetriever';

import Drawer from '../../Drawer';
import Cart from '../../../containers/Cart';

import history from '../../../history';
import PushHistory from '../../../utils/PushHistory';

import TabGenerator from './TabGenerator';

import './index.scss';

export default (props) => {
    const [ modalCart, setModalCart ] = React.useState(false);

    const openSideCart = () => {
        const mc = !modalCart;
        const blacklistedPaths = [
            '/shopping-cart/review',
            '/checkout/register',
            '/checkout/payment',
            '/checkout/customer-requirements',
            '/checkout/review',
            '/checkout/confirmed',
            '/checkout/completed/v2',
            '/checkout/error',
            '/logout',
            '/checkout/resetpassword'
        ];
        if (blacklistedPaths.indexOf(history.location.pathname) >= 0) {
            PushHistory('/shopping-cart/review');
        } else {
            setModalCart(mc);
            props.onCollapse();
        }
    }

    const closeSideCart = () => {
        setModalCart(false);
        props.onCollapse();
    }

    if (props.showCartDrawer && !modalCart) openSideCart();

    return (
        <React.Fragment>
            <Drawer disablePortal={true} onEscapeKeyDown={() => closeSideCart()} onBackdropClick={() => closeSideCart()} variant={'temporary'} anchor={'right'} open={modalCart} className="summaryCartDrawer">
                <Cart isDrawer={true}/>
            </Drawer>
            <nav className="newNavWrapper">
                {!getSelectedPromocode() ?  <TabGenerator openSideCart={() => openSideCart()} showCartDrawer={props.showCartDrawer} onTrigger={props.onTrigger} onCollapse={props.onCollapse} cart={true}/> : null}
            </nav>
        </React.Fragment>
    );
}
